import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { ContactUsModule } from './contact-us/contact-us.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { JobsModule } from './jobs/jobs.module';
import { CityModule } from './city/city.module';
import { MaterialModule } from './shared/material.module';
import { AuthModule } from './auth/auth.module';
import { AboutDhadukFamilyModule } from './about-dhaduk-family/about-dhaduk-family.module';
import { StudentResultModule } from './student-result/student-result.module';
import { ProfileModule } from './profile/profile.module';
import { DonorModule } from './donor/donor.module';
import { MemoryModule } from './memory/memory.module';
import { MasterModule } from './master/master.module';
import { NRIModule } from './NRI/nri.module';
import { CommitteeModule } from './committee/committee.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { loaderInterceptor } from './service/loader.interceptor';
import { HttpErrorInterceptor } from './service/http-error.interceptor';
import { RouterModule } from '@angular/router';
import { NotificationModule } from './notification/notification.module';
import { QrScannerComponent } from './qr-scanner/qr-scanner.component';
import { EventComponent } from './event/event.component';
import { AddEditEventComponent } from './event/add-edit-event/add-edit-event.component';
import { SubEventComponent } from './sub-event/sub-event.component';
import { AddEditSubEventComponent } from './sub-event/add-edit-sub-event/add-edit-sub-event.component';
import { InvitaionPresentmMemebrComponent } from './sub-event/invitaion-presentm-memebr/invitaion-presentm-memebr.component';
import { SendInvitationComponent } from './sub-event/send-invitation/send-invitation.component';
import { EventDonorListComponent } from './sub-event/event-donor-list/event-donor-list.component';
import { AddEventDonorComponent } from './sub-event/event-donor-list/add-event-donor/add-event-donor.component';
import { MenunalInvitationComponent } from './sub-event/menunal-invitation/menunal-invitation.component';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from '@angular/material/core';
import { EventDonorComponent } from './event-donor/event-donor.component';
import { SubEventDonorComponent } from './event-donor/sub-event-donor/sub-event-donor.component';
import { EventDonorMenulistComponent } from './event-donor/event-donor-menulist/event-donor-menulist.component';
import { ReminderModule } from './reminder/reminder.module';
import { initializeApp } from "firebase/app";
import { environment } from '../environments/environment';
initializeApp(environment.firebaseConfig);
@NgModule({
  declarations: [
    AppComponent,
    QrScannerComponent,
    EventComponent,
    AddEditEventComponent,
    SubEventComponent,
    AddEditSubEventComponent,
    InvitaionPresentmMemebrComponent,
    SendInvitationComponent,
    EventDonorListComponent,
    AddEventDonorComponent,
    MenunalInvitationComponent,
    EventDonorComponent,
    SubEventDonorComponent,
    EventDonorMenulistComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    DashboardModule,
    ContactUsModule,
    // JobsModule,
    CityModule,
    AuthModule,
    AboutDhadukFamilyModule,
    StudentResultModule,
    ProfileModule,
    DonorModule,
    MemoryModule,
    MasterModule,
    NRIModule,
    NotificationModule,
    MaterialModule,
    CommitteeModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    NgxSpinnerModule,
    ReminderModule
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: loaderInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: DateAdapter, useClass: MomentDateAdapter },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
